<div class="modal-header" id="duration-manual-input-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DURATION_MANUAL_INPUT_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="durationManualInputForm">
        <div class="row mb-3">
            <div class="col">
                <label for="hoursInput" translate="DURATION_MANUAL_INPUT_HOURS"></label>
                <input
                    type="text"
                    inputmode="numeric"
                    id="hoursInput"
                    [formControl]="hoursInputControl"
                    #hoursInput
                    paceCoreNumberOnly
                    [maxLength]="inputMaxLength"
                    (keyup)="onHoursKeyUp($event, hoursInput)"
                    (keyup.enter)="submitDurationOnEnter()"
                    class="form-control input-md number-input"
                />
            </div>
            <div class="col">
                <label for="minutesInput" translate="DURATION_MANUAL_INPUT_MINUTES"></label>
                <input
                    type="text"
                    inputmode="numeric"
                    id="minutesInput"
                    #minutesInput
                    paceCoreNumberOnly
                    [maxLength]="inputMaxLength"
                    [maxValue]="inputMinuteMaxValue"
                    [step]="model.options.step"
                    [formControl]="minutesInputControl"
                    (keyup.enter)="submitDurationOnEnter()"
                    class="form-control input-md number-input"
                />
            </div>
        </div>
        @for (error of objectToArray(durationManualInputForm.errors); track error) {
            <div class="row mb-3">
                <small class="col error">{{ error }}</small>
            </div>
        }
    </form>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        type="button"
        translate="DURATION_STEPPER_CANCEL"
        (click)="modalInstance.hide()"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        translate="DURATION_STEPPER_DONE"
        [disabled]="durationManualInputForm.invalid"
        (click)="onSave()"
    ></button>
</div>
